import { render, staticRenderFns } from "./KPList.vue?vue&type=template&id=127c189f&scoped=true&"
import script from "./KPList.vue?vue&type=script&lang=js&"
export * from "./KPList.vue?vue&type=script&lang=js&"
import style0 from "./KPList.vue?vue&type=style&index=0&id=127c189f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c189f",
  null
  
)

export default component.exports